module.exports = __webpack_public_path__ + "img/ics_download-template.492e097f.svg";